'use client'
import type { ReactNode } from 'react'
import { createContext, useContext, useEffect, useId, useRef, useState } from 'react'
import { cx } from '../utils'

export function Tabs<T extends string>({
  tabs,
  value,
  onChange,
}: {
  tabs: Array<{ id: T; label: string; count?: number }>
  value: T
  onChange: (id: T) => void
}) {
  return (
    <div role="tablist" className="flex items-end gap-5 border-b border-line">
      {tabs.map((tab) => {
        const active = tab.id === value
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={cx(
              'pxs-focus -mb-px border-b-2 pb-2 text-[15px] transition-colors duration-100',
              active
                ? 'border-accent font-medium text-ink'
                : 'border-transparent text-ink-3 hover:text-ink',
            )}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span className="ml-1.5 font-mono text-[13px] text-ink-3">{tab.count}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
